"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.getDealerId = exports["default"] = void 0;
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));
var _react = _interopRequireDefault(require("react"));
var _clsx2 = _interopRequireDefault(require("clsx"));
var _graphqlTag = _interopRequireDefault(require("graphql-tag"));
var _reactApollo = require("react-apollo");
var _commonCta = require("@mmc/common-cta");
var _commonLoader = require("@mmc/common-loader");
var _dealerDetails = _interopRequireDefault(require("./dealer-details"));
var propTypes = _interopRequireWildcard(require("./mini-dealer-locator.prop-types"));
var _dealerCard = _interopRequireDefault(require("./dealer-card"));
var _dealersList = _interopRequireDefault(require("./dealers-list.css"));
var _commonLibs = require("@mmc/common-libs");
var _commonSetLocation = require("@mmc/common-set-location");
var _templateObject, _CommonLoader;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var DEFAULT_ITEMS_PER_ROW = 4;
var getDealerId = function getDealerId(dealer) {
  var getId = function getId(id, marketId, address, phone, url) {
    if (marketId === void 0) {
      marketId = '';
    }
    if (address === void 0) {
      address = '';
    }
    if (phone === void 0) {
      phone = '';
    }
    if (url === void 0) {
      url = '';
    }
    return [id, marketId, dealer.name, address, phone, url].join('|');
  };
  return dealer.dealershipMarketId && dealer.dealershipMarketId !== '' && dealer.dealershipMarketId !== null ? getId(dealer.id, dealer.dealershipMarketId, dealer.address, dealer.phone.phoneNumber, dealer.url) : getId(dealer.id);
};
exports.getDealerId = getDealerId;
var DEALER_QUERY = (0, _graphqlTag["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteralLoose2["default"])(["\n  query getDealerDetail(\n    $market: String!\n    $language: String!\n    $dealerId: Int!\n    $path: String\n  ) {\n    getDealerDetail(\n      market: $market\n      language: $language\n      dealerId: $dealerId\n      path: $path\n    ) {\n      email\n      phone {\n        phoneType\n        countryCode\n        areaCode\n        phoneNumber\n        extensionNumber\n      }\n      dealerFilterTags\n      dealerDepartments {\n        name\n        code\n        email\n        phone {\n          phoneType\n          countryCode\n          areaCode\n          phoneNumber\n          extensionNumber\n        }\n        workingHours {\n          dayOfTheWeek\n          openTime\n          closeTime\n          status\n        }\n      }\n      scheduleServiceUrl\n      searchInventoryUrl\n    }\n  }\n"])));
var DealersList = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inheritsLoose2["default"])(DealersList, _React$PureComponent);
  function DealersList(props) {
    var _this;
    _this = _React$PureComponent.call(this, props) || this;
    _this.state = {
      resultCount: props.itemsPerRow,
      showDealersDetails: false,
      value: ''
    };
    _this.selectedDealer = {};
    _this.selectedId = undefined;
    _this.multiSelectDealersMap = {};
    _this.isDealerSelected = _this.isDealerSelected.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleDealerChange = _this.handleDealerChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getSelectedDealers = _this.getSelectedDealers.bind((0, _assertThisInitialized2["default"])(_this));
    _this.viewMore = _this.viewMore.bind((0, _assertThisInitialized2["default"])(_this));
    _this.toggleDetails = _this.toggleDetails.bind((0, _assertThisInitialized2["default"])(_this));
    _this.editHandler = _this.editHandler.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  var _proto = DealersList.prototype;
  _proto.handleDealerChange = function handleDealerChange(e) {
    var _this$props = this.props,
      onChange = _this$props.onChange,
      isMapEnabled = _this$props.isMapEnabled,
      dealers = _this$props.dealers,
      getDealerSelected = _this$props.getDealerSelected;
    var selectedDealers = this.getSelectedDealers(e.target.value);
    var selectedDealerId = selectedDealers[0].split('|')[0];
    this.selectedId = selectedDealerId;
    var dealerlist = dealers;
    this.selectedDealer = dealerlist.find(function (dealer) {
      if (Number(dealer.id) === Number(selectedDealerId)) {
        return dealer;
      }
      return null;
    });
    if (isMapEnabled) {
      this.setState({
        showDealersDetails: true
      });
    }
    getDealerSelected(this.selectedDealer);
    /* Set PostalCode of dealer in storage for clickshop bridge */
    var dealerLocation = this.selectedDealer.dealerLocation;
    var postalArea = dealerLocation.postalArea;
    if (postalArea) {
      (0, _commonLibs.setDealerPostalCodeInDealerCache)(postalArea);
    } else {
      var latitude = dealerLocation.latitude,
        longitude = dealerLocation.longitude;
      this.retryGeocodeWithLatlng(latitude, longitude);
    }
    if (onChange) {
      onChange(selectedDealers);
    }
    this.setState({
      value: selectedDealers[0]
    });
  };
  _proto.retryGeocodeWithLatlng = function retryGeocodeWithLatlng(lat, lng) {
    var latLng = new google.maps.LatLng(parseFloat(lat), parseFloat(lng));
    var lookup = {
      latLng: latLng
    };
    var geocoder = new window.google.maps.Geocoder();
    geocoder.geocode(lookup, function (results, status) {
      if (status === window.google.maps.GeocoderStatus.OK) {
        var postalCode = (0, _commonSetLocation.getPostalCodeFromGooglePlaceResults)(results);
        (0, _commonLibs.setDealerPostalCodeInDealerCache)(postalCode);
      }
    });
  };
  _proto.getSelectedDealers = function getSelectedDealers(dealerId) {
    var _this2 = this;
    var multiSelect = this.props.multiSelect;
    if (multiSelect) {
      var SelectedDealersCount = Object.values(this.multiSelectDealersMap).filter(function (item) {
        return item === true;
      }).length;
      if (SelectedDealersCount < 2) {
        this.multiSelectDealersMap[dealerId] = !this.multiSelectDealersMap[dealerId];
      } else {
        this.multiSelectDealersMap[dealerId] = false;
      }
      return Object.keys(this.multiSelectDealersMap).filter(function (key) {
        return _this2.multiSelectDealersMap[key];
      });
    }
    return [dealerId];
  };
  _proto.toggleDetails = function toggleDetails() {
    var toggleListMapSearch = this.props.toggleListMapSearch;
    this.setState({
      showDealersDetails: false
    });
    toggleListMapSearch();
  };
  _proto.isDealerSelected = function isDealerSelected(dealer) {
    var _ref = typeof this.props.value !== 'undefined' ? this.props : this.state,
      value = _ref.value;
    /* If value is not available from CONSTRUCTED FORM, the value is stored in state */
    return Boolean(value) && value.includes(getDealerId(dealer));
  };
  _proto.viewMore = function viewMore(e) {
    e.preventDefault();
    var itemsPerRow = this.props.itemsPerRow;
    this.setState(function (prevState) {
      return {
        resultCount: prevState.resultCount + itemsPerRow
      };
    });
  };
  _proto.editHandler = function editHandler() {
    var showDealersDetails = this.state.showDealersDetails;
    var toggleListMapSearch = this.props.toggleListMapSearch;
    this.setState({
      showDealersDetails: !showDealersDetails
    });
    toggleListMapSearch();
  };
  _proto.dealerDetail = function dealerDetail() {
    var _this3 = this;
    var _this$props2 = this.props,
      market = _this$props2.market,
      language = _this$props2.language,
      path = _this$props2.path,
      value = _this$props2.value,
      theme = _this$props2.theme,
      location = _this$props2.location,
      getDealerDepartment = _this$props2.getDealerDepartment,
      saleOpeningHoursLabel = _this$props2.saleOpeningHoursLabel,
      serviceOpeningHoursLabel = _this$props2.serviceOpeningHoursLabel,
      salesLabel = _this$props2.salesLabel,
      servicesLabel = _this$props2.servicesLabel,
      selectedLabel = _this$props2.selectedLabel,
      editLabel = _this$props2.editLabel;
    var showDealersDetails = this.state.showDealersDetails;
    var filterSelectedDealer = value.toString().split('|');
    var id = parseInt(filterSelectedDealer[0], 10);
    var queryParams = function queryParams(dealerId, pathArg) {
      return {
        dealerId: dealerId,
        market: market,
        language: language,
        path: pathArg
      };
    };
    return /*#__PURE__*/_react["default"].createElement(_reactApollo.Query, {
      query: DEALER_QUERY,
      variables: queryParams(id, path)
    }, function (_ref2) {
      var _this3$selectedDealer, _this3$selectedDealer2;
      var loading = _ref2.loading,
        data = _ref2.data;
      // TODO: build proper hanlding for additional services
      var departmentstoUseForHours = [];
      if (data) {
        if (data.getDealerDetail) {
          departmentstoUseForHours = data.getDealerDetail.dealerDepartments.filter(function (department) {
            return department.workingHours.length > 0;
          });
        }
      }
      var departmentsCode = [];
      if (data) {
        if (data.getDealerDetail) {
          departmentsCode = data.getDealerDetail.dealerDepartments.map(function (department) {
            return department.code;
          });
        }
      }
      getDealerDepartment(departmentstoUseForHours, departmentsCode);
      return /*#__PURE__*/_react["default"].createElement("div", null, loading && location && (_CommonLoader || (_CommonLoader = /*#__PURE__*/_react["default"].createElement(_commonLoader.CommonLoader, null))), !loading && showDealersDetails && data && data.getDealerDetail.dealerDepartments && data.getDealerDetail.dealerDepartments.length > 0 && /*#__PURE__*/_react["default"].createElement(_dealerDetails["default"], {
        dealerName: (_this3$selectedDealer = _this3.selectedDealer) == null ? void 0 : _this3$selectedDealer.name,
        dealerAddress: (_this3$selectedDealer2 = _this3.selectedDealer) == null ? void 0 : _this3$selectedDealer2.address,
        dealerDepartments: departmentstoUseForHours,
        theme: theme,
        departmentsCode: departmentsCode,
        editHandler: _this3.editHandler,
        selectedLabel: selectedLabel,
        editLabel: editLabel,
        salesLabel: salesLabel,
        servicesLabel: servicesLabel,
        saleOpeningHoursLabel: saleOpeningHoursLabel,
        serviceOpeningHoursLabel: serviceOpeningHoursLabel
      }));
    });
  };
  _proto.render = function render() {
    var _clsx,
      _this4 = this;
    var _this$state = this.state,
      resultCount = _this$state.resultCount,
      showDealersDetails = _this$state.showDealersDetails;
    var _this$props3 = this.props,
      theme = _this$props3.theme,
      multiSelect = _this$props3.multiSelect,
      viewMoreText = _this$props3.viewMoreText,
      showRating = _this$props3.showRating,
      distance = _this$props3.distance,
      isMapEnabled = _this$props3.isMapEnabled,
      isMobile = _this$props3.isMobile,
      dealers = _this$props3.dealers;
    var hasViewMoreBtn = isMobile || !isMapEnabled ? dealers.length > resultCount : false;
    var type = multiSelect ? 'checkbox' : 'radio';
    var partial = isMobile || !isMapEnabled ? dealers.slice(0, resultCount) : dealers;
    return /*#__PURE__*/_react["default"].createElement("div", null, isMapEnabled ? /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx2["default"])(_dealersList["default"].results, (_clsx = {}, _clsx[_dealersList["default"].hideDealersList] = showDealersDetails, _clsx))
    }, partial.map(function (dealer, key) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _dealersList["default"].card,
        key: dealer.id || key
      }, /*#__PURE__*/_react["default"].createElement(_dealerCard["default"], {
        dealer: dealer,
        type: type,
        theme: theme,
        value: getDealerId(dealer),
        onChange: _this4.handleDealerChange,
        isSelected: _this4.isDealerSelected(dealer),
        showRating: showRating,
        distance: distance,
        isMapEnabled: isMapEnabled
      }));
    })) : /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx2["default"])(theme.row, _dealersList["default"].results)
    }, partial.map(function (dealer, key) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _clsx2["default"])(theme['col-xs-12'], theme['col-md-4'], _dealersList["default"].card, _dealersList["default"].dealerCardContainer),
        key: dealer.id || key
      }, /*#__PURE__*/_react["default"].createElement(_dealerCard["default"], {
        dealer: dealer,
        type: type,
        theme: theme,
        value: getDealerId(dealer),
        onChange: _this4.handleDealerChange,
        isSelected: _this4.isDealerSelected(dealer),
        showRating: showRating,
        distance: distance,
        isMapEnabled: isMapEnabled
      }));
    })), !showDealersDetails && hasViewMoreBtn && /*#__PURE__*/_react["default"].createElement("div", {
      className: _dealersList["default"].dealerViewMore
    }, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
      clickEvent: this.viewMore,
      data: {
        label: viewMoreText || 'View more',
        priority: 'lowIcon',
        icon: 'ChevronDown'
      },
      iconRight: true,
      theme: theme
    })), showDealersDetails && this.dealerDetail());
  };
  return DealersList;
}(_react["default"].PureComponent);
exports["default"] = DealersList;
DealersList.defaultProps = {
  itemsPerRow: DEFAULT_ITEMS_PER_ROW
};